const SaveButton = ({
    label="Save Changes",
    haveChanges=false,
    clickHandler
}) => {

    return (
        <div className="save-button-wrapper">
            <button
                className="save-btn"
                type="button"
                disabled={!haveChanges}
                onClick={clickHandler}
            >
                {label}
            </button>
        </div>
    )
}

export default SaveButton